<template>
  <div class="contianer-fluid">
    <div class="row">
      <div class="col-xs-3">
        <SelectableList
          v-model="selectedWaveIds"
          :options="shortedWaves"
          :getItemClasses="getItemClasses"
          :getItemLabel="getItemLabel"
          :getItemValue="getItemValue"
        />
      </div>
      <div class="col-xs-9">
        <OrderTable
          :orders="shortedOrders"
          :cols="[
            'Order #',
            'Account',
            'Truck',
            'Zone',
            'Qty Req',
            'Qty Scnd',
            'Status',
            'Action',
          ]"
          :getRowButtonText="getRowButtonText"
          :getRowButtonVisible="getRowButtonVisible"
          :getRowRolloverButtonVisible="getRowRolloverButtonVisible"
          @onRowButtonClick="handleRowButtonClick"
          @onRowRolloverButtonClick="handleRolloverButtonClick"
        >
          <template slot="searchHelpText">
            <p>{{ searchHelperText }}</p>
          </template>
          <btn
            v-if="
              $apollo.queries.shortedWaves.loading ||
              $apollo.queries.shortedOrders.loading
            "
            disabled
            >Refreshing...</btn
          >
          <btn v-else @click="refreshData"> Refresh </btn>
        </OrderTable>
      </div>
      <PublishShortModal
        :order="selectedShortedOrder"
        @onClose="handleModalClose"
      />
      <RolloverModal
        :order="selectedRolloverOrder"
        @onClose="handleRolloverModalClose"
      />
    </div>
  </div>
</template>

<script>
import { getShortedWaves, getShortedOrders } from '@/queries';
import { pluralize } from '@/utils';

export default {
  name: 'Shorts',
  props: ['pickDate'],
  watch: {
    selectedWaveIds(value) {
      if (value.length === 0) {
        this.shortedOrders = [];
        this.selectedShortedOrder = null;
      }
    },
  },
  data() {
    return {
      errors: [], // TODO: render errors
      shortedWaves: [],
      selectedWaveIds: [],
      shortedOrders: [],
      selectedShortedOrder: null,
      selectedRolloverOrder: null,
    };
  },
  computed: {
    selectedWaves() {
      return this.selectedWaveIds.map((waveId) =>
        this.shortedWaves.find((wave) => wave.id === waveId)
      );
    },
    searchHelperText() {
      if (this.selectedWaves.length === 0) {
        return `Search all orders`;
      }
      return `Search in ${pluralize(
        this.selectedWaves.length,
        'selected wave'
      )}`;
    },
  },
  methods: {
    refreshData() {
      this.$apollo.queries.shortedOrders.refetch();
      this.$apollo.queries.shortedWaves.refetch();
    },
    handleRowButtonClick(order) {
      this.selectedShortedOrder = order;
    },
    handleRolloverButtonClick(order) {
      this.selectedRolloverOrder = order;
    },
    handleModalClose() {
      this.selectedShortedOrder = null;
    },
    handleRolloverModalClose() {
      this.selectedRolloverOrder = null;
    },
    getRowButtonText(row) {
      return row.publishedAt ? 'Re-publish' : 'Reconcile';
    },
    getRowButtonVisible(row) {
      return row.boxesScanned !== row.boxesRequested;
    },
    getRowRolloverButtonVisible(row) {
      return (
        row.boxesScanned !== row.boxesRequested &&
        (row.status === 'new' || row.status === 'picked')
      );
    },
    getItemClasses(wave) {
      return {
        'Shorts__wave--published': wave.isFullyPublished,
        'Shorts__wave--unpublished': !wave.isFullyPublished,
      };
    },
    getItemLabel(wave) {
      if (wave.isFullyPublished) {
        return `${wave.name} (published)`;
      }
      return wave.name;
    },
    getItemValue(wave) {
      return wave.id;
    },
  },
  apollo: {
    shortedWaves: {
      query: getShortedWaves,
      variables() {
        return {
          pickDate: this.pickDate,
        };
      },
      error({ networkError, graphQLErrors }) {
        if (networkError) {
          this.errors.push(
            'There was a network error. Please refresh the page and try again.'
          );
        }
        if (graphQLErrors.length > 0) {
          graphQLErrors.forEach((error) => {
            this.errors.push(error.message);
          });
        }
      },
    },
    shortedOrders: {
      query: getShortedOrders,
      update(data) {
        return data.shortedOrders;
      },
      variables() {
        return {
          pickDate: this.pickDate,
          waveIds: this.selectedWaveIds,
        };
      },
      error({ networkError, graphQLErrors }) {
        if (networkError) {
          this.errors.push(
            'There was a network error. Please refresh the page and try again.'
          );
        }
        if (graphQLErrors.length > 0) {
          graphQLErrors.forEach((error) => {
            this.errors.push(error.message);
          });
        }
      },
    },
  },
};
</script>

<style>
/* Expliticly NOT 'scoped', because we want to style the child component SelectableList */
a.list-group-item.Shorts__wave--published {
  font-style: italic;
}

a.list-group-item.Shorts__wave--unpublished {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/Shorts.vue